import { unionWith } from "lodash";

import { ConsultationDetails } from "@teamprevent/common/model";

import * as actions from "./actionTypes";
import { ConsultationLoadedSuccess } from "./actions";

export function consultationDetails(
    state: ConsultationDetails[] = [],
    action: ConsultationLoadedSuccess): ConsultationDetails[] {
    switch (action.type) {
        case actions.CONSULTATION_LOAD_SUCCESS:
            return unionWith(
                [action.payload],
                state,
                (a, b) => a.consultationTaskId === b.consultationTaskId
            );
        default:
            return state;
    }
}
